var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "title-text" },
    [
      _vm.hasTitle === true
        ? _c("h5", { staticClass: "section-title" }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.textWithBreaks, function(p, index) {
        return _c(
          "p",
          { key: index },
          _vm._l(p, function(l, j) {
            return _c("span", { key: j }, [
              j > 0 ? _c("br") : _vm._e(),
              _vm._v("\n            " + _vm._s(l) + "\n        ")
            ])
          }),
          0
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }